"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "@/models/tags.model";
import i18n from "@/lang";
export let InfoNewOptionsRegionTagsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.property = null;
  }
  //？？？？
};
InfoNewOptionsRegionTagsModel.model = "tag.item";
InfoNewOptionsRegionTagsModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsRegionTagsModel);
export let InfoNewOptionsStockModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.goods_stock_left = 0;
  }
  //是否售罄
};
InfoNewOptionsStockModel.model = "payment.virtualdesktop.options.create.goods_stock";
InfoNewOptionsStockModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsStockModel);
export let InfoNewOptionsLimitModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.min = 0;
    this.max = 0;
  }
};
InfoNewOptionsLimitModel.model = "payment.virtualdesktop.options.create.buy_limit";
InfoNewOptionsLimitModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsLimitModel);
export let InfoNewOptionsGoodsSpecModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    //商品规格id
    this.spec_name = "";
    //商品规格名
    this.visible = false;
    this.month_price = 0;
    // 一个月的价格
    this.discount_tag = "";
    this.price_description = "";
    this.currency = "CNY";
    this.marks = new TagsModel();
  }
};
InfoNewOptionsGoodsSpecModel.model = "payment.virtualdesktop.goods.Spec";
InfoNewOptionsGoodsSpecModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsGoodsSpecModel);
export let InfoNewOptionsDefaultSelectionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.timezone_id = "";
    //默认时区id
    this.language_id = "";
    //默认语言id
    this.country_id = "";
  }
  //默认国家id
};
InfoNewOptionsDefaultSelectionModel.model = "payment.virtualdesktop.options.create.region_default_selection";
InfoNewOptionsDefaultSelectionModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsDefaultSelectionModel);
export let InfoNewOptionsNoSupportEbusinessModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.caption = "";
    this.code = "";
    this.sort = 0;
    this.support = false;
    this.tip = null;
  }
};
InfoNewOptionsNoSupportEbusinessModel.model = "payment.virtualdesktop.options.create.support_ebusiness_platform";
InfoNewOptionsNoSupportEbusinessModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsNoSupportEbusinessModel);
export let InfoNewOptionsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
    this.region_tags = new InfoNewOptionsRegionTagsModel();
    this.stock = new InfoNewOptionsStockModel();
    this.limit = new InfoNewOptionsLimitModel();
    this.risk_level = 0;
    this.sortValue = 0;
    this.month_spec = 0;
    this.show_auto_timezone = false;
    this.show_auto_renew = false;
    this.marks = new TagsModel();
    this.payment = [];
    this.payments = [];
    this.goods_spec = new Array();
    this.default_selection = new InfoNewOptionsDefaultSelectionModel();
    this.no_support_ebusiness = new Array();
    this.image_style = null;
    this.month_original_spec = null;
    this.info_tags = null;
    this.lable_tags = null;
    this.left_tags = null;
    this.recommend_star = null;
    this.comment = null;
    this.currency = "CNY";
    this.region_tip = null;
    this.tips = null;
  }
  disabled() {
    if (this.stock.goods_stock_left === 0) {
      return true;
    }
    return false;
  }
  stock_tag() {
    if (this.stock.goods_stock_left <= -1) {
      return null;
    }
    if (this.stock.goods_stock_left === 0) {
      return i18n.t("selectoptions.goods.left");
    }
    return this.stock.goods_stock_left;
  }
};
InfoNewOptionsModel.model = "payment.virtualdesktop.options.create.region";
InfoNewOptionsModel = __decorateClass([
  Annotation.ModelMeta
], InfoNewOptionsModel);
